import React, { useState } from 'react';

import {
  BAR_HEIGHT,
  BAR_ORIGIN_X,
  BAR_ORIGIN_Y,
  BAR_WIDTH,
  BaseBar,
  EndText,
  HEIGHT,
  PercentText,
  StartText,
  WIDTH,
} from './SVG';

interface Props {
  low: number;
  high: number;
  current: number;
  lowest: number;
  highest: number;
  lowestLabel: string | number;
  highestLabel: string | number;
}

const RelChart: React.FC<Props> = ({
  low,
  high,
  current,
  lowest,
  highest,
  lowestLabel,
  highestLabel,
}) => {
  const [isOnHover, setIsOnHover] = useState<boolean>(false);
  const handleOnHoverStart = () => {
    if (!isOnHover && !Number.isNaN(currentPercent)) {
      setIsOnHover(true);
    }
  };

  const handleOnHoverEnd = () => {
    setIsOnHover(false);
  };

  const span = highest - lowest;
  const xLow =
    span === 0
      ? BAR_ORIGIN_X
      : ((low - lowest) / span) * BAR_WIDTH + BAR_ORIGIN_X;
  const xHigh =
    span === 0
      ? BAR_ORIGIN_X + BAR_WIDTH
      : ((high - lowest) / span) * BAR_WIDTH + BAR_ORIGIN_X;
  const xCurrent = ((current - lowest) / span) * BAR_WIDTH + BAR_ORIGIN_X;
  const currentPercent = (current - lowest) / (highest - lowest);
  // Control percent appearing on the left or right of the mark to prevent overflow
  const percentX =
    currentPercent < 0.8
      ? xCurrent + BAR_HEIGHT / 2 + 1
      : xCurrent - BAR_HEIGHT / 2;
  // Ensure the text doesn't cover the mark
  const textAnchor = currentPercent < 0.8 ? 'start' : 'end';

  return (
    <svg
      viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
      onMouseOver={handleOnHoverStart}
      onMouseLeave={handleOnHoverEnd}
      onTouchStart={handleOnHoverStart}
      onTouchEnd={handleOnHoverEnd}
    >
      <BaseBar />
      <rect
        x={xLow - 0.5}
        y={BAR_ORIGIN_Y}
        width={xHigh - xLow + 1}
        height={BAR_HEIGHT}
        style={{
          fill: '#128DFA',
        }}
      />
      <polygon
        points={`${xCurrent}, ${BAR_ORIGIN_Y} ${xCurrent - BAR_HEIGHT / 2}, ${
          BAR_ORIGIN_Y - 2 * BAR_HEIGHT
        } ${xCurrent + BAR_HEIGHT / 2}, ${BAR_ORIGIN_Y - 2 * BAR_HEIGHT}`}
        style={{
          fill: '#128DFA',
        }}
      />
      <PercentText
        currentX={percentX}
        textAnchor={textAnchor}
        isOnHover={isOnHover}
        currentPercent={currentPercent}
        fixed={2}
      />
      <StartText>{lowestLabel}</StartText>
      <EndText>{highestLabel}</EndText>
    </svg>
  );
};

export default React.memo(RelChart);
